import apiFetch from '../apiFetch'

export default function (idLinea, token) {
  return apiFetch({endPoint: `LineaGenetica/getLineaGeneticaParaDuplicar?idLinea=${idLinea}`, method: 'GET', body: null, token: token})
}
